import { useApiMutation } from '@/composables/useApi';
import { optInEndpoints } from '@/services/api/apiConfig';
import type { OptInRequest, OptInResponse } from '@/domains/auth/types/OptIn';

export const useOptInMutation = () => {
  return useApiMutation<OptInResponse, Error, OptInRequest>({
    endpoint: optInEndpoints.SUBMIT(),
    method: 'post',
    mapVariablesToRequest: (variables) => {
      return { body: variables };
    },
  });
};
